<button
    *ngFor="let chip of list"
    (click)="selectedId = chip.id"
    type="button"
    class="chip-radio"
    [ngClass]="{ selected: selectedId === chip.id }"
>
    {{ chip.label }}
</button>
